var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "flicker live-counter", class: _vm.computedClasses },
    [
      _vm._t("default"),
      _vm._v("\n  " + _vm._s(_vm.hasSlots ? "" : _vm.cellValue) + "\n")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }